export const API_URL = "https://lkbe.frprf.ru/ws/restapi/v1/";
export const AUTH_URL = "https://lkbe.frprf.ru/";
export const IS_DEV_MODE = false;
